import React, { useEffect, useContext, useState } from "react";
import home from "assets/images/home.png";
import vertical from "assets/images/vertical.png";
import homeE from "assets/images/home_e.png";
import verticalE from "assets/images/vertical_e.png";
import { Header } from "components";
import { Button } from "antd";
import { instance } from "utils/axios";
import { useWindowSize } from "react-use";
import ReactConfetti from "react-confetti";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthContext } from "contexts";

function Decision() {
  const navigate = useNavigate();
  const { width, height } = useWindowSize();
  const { state, action } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [childName, setChildName] = useState(null);
  // Олон хүүхэдтэй эцэг эхийн логин: сонгосон хүүхдийн id query-ээр ирнэ.
  // Параметргүй үед хуучин шигээ — нэг хүүхэдтэй айлд өөрчлөлтгүй.
  const [searchParams] = useSearchParams();
  const applicantId = searchParams.get("applicantId");
  const childQ = applicantId ? `?applicantId=${applicantId}` : "";
  const name = childName || state.studentInfo?.profile?.firstName;

  useEffect(() => {
    setLoading(true);
    instance({ method: "get", url: `/applicant/decision/view${childQ}` })
      .then((res) => setData(res.data))
      .catch(() => { })
      .finally(() => setLoading(false));
    if (applicantId) {
      instance({ method: "get", url: "/applicant/children" })
        .then((res) => {
          const c = (res.data || []).find((x) => String(x.id) === String(applicantId));
          if (c) setChildName(c.firstName);
        })
        .catch(() => { });
    }
  }, []);

  if (data?.status !== "Accept") return <div>Page Not found</div>;

  // ── 1-Р АНГИЙН (бага сургуулийн) хувилбар — эцэг эхэд зориулсан захидал.
  // Үндсэн (5-11 ангийн) хуудасны логик доор ХЭВЭЭРЭЭ, огт өөрчлөгдөөгүй.
  if (String(data?.grade || "") === "1") {
    return (
      <div className="relative">
        <Header />
        {/* Олон хүүхэдтэй эцэг эх — нүүр рүү буцаж өөр хүүхдээ сонгох боломж */}
        {applicantId && (
          <button
            onClick={() => navigate("/")}
            className="fixed top-3 right-24 z-[60] text-white bg-black/25 hover:bg-black/45 border border-white/40 rounded-full px-4 py-1.5 text-sm cursor-pointer transition-all"
          >
            ← Буцах
          </button>
        )}
        {/* Гарах товч */}
        <button
          onClick={() => action.logout()}
          className="fixed top-3 right-5 z-[60] text-white bg-black/25 hover:bg-black/45 border border-white/40 rounded-full px-4 py-1.5 text-sm cursor-pointer transition-all"
        >
          Гарах
        </button>
        <div
          id="home-section"
          className="w-full flex justify-center items-center overflow-x-hidden relative"
          style={{
            background: `url(${width < height ? verticalE : homeE})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            height: width < height ? "45vh" : "100vh",
          }}
        >
          <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.10)" }} />
          <ReactConfetti gravity={0.2} style={{ width: "100%", height: "100vh" }} />
          <div className="max-w-[1280px] px-10 sm:px-24 xl:px-0 text-white sm:block relative z-10">
            <h1 className="text-[24pt] sm:text-[40pt] md:text-[60pt] xl:text-[80pt] font-extrabold leading-none">
              БАЯР ХҮРГЭЕ!
            </h1>
            <div className="mt-[34pt] text-[20pt] md:text-[35pt] xl:text-[50pt] leading-[1.38]">
              Таны хүүхэд Томүжин Алтернатив сургуульд ТЭНЦЛЭЭ!
            </div>
          </div>
        </div>

        <div className="w-full min-h-screen flex justify-center items-center">
          <div className="max-w-[1280px]">
            <div className="w-2/3 flex flex-col gap-4 mx-auto py-20 md:py-0 font-sans">
              <div className="text-[20pt] md:text-[40pt] xl:text-[50pt] font-extrabold text-primary leading-[1.38]">
                Эрхэм хүндэт эцэг эх танаа,
              </div>
              <div className="mt-10 font-sans">
                Юуны түрүүнд хайрт үрийнхээ амьдралын хамгийн анхны, хамгийн
                чухал алхмыг Томүжин Алтернатив сургуультай хамт эхлүүлэхээр
                шийдсэн танд гүн талархал илэрхийлж, халуун БАЯР ХҮРГЭЕ! Таны
                хүүхэд Монгол улсын өнцөг булан бүрээс цугласан, суралцах хүсэл
                тэмүүллээр дүүрэн хүрээллийн нэг хэсэг болж, олон зуун жил
                шинэчлэгдээгүй хэвшмэл боловсролыг халж #Алтернатив сургалтын
                арга технологийг эрэлхийлэх бидний энэхүү аялалд хамгийн бяцхан
                гишүүнээр нэгдэж байгаа юм.
              </div>
              <div>
                Бага нас бол хүүхдийн сониуч зан, өөртөө итгэх итгэл, суралцах
                хайрын суурь тавигддаг хамгийн үнэ цэнтэй үе. Томүжин
                Алтернатив сургуульд таны хүүхэд аюулгүй, хайр халамжтай
                орчинд асуулт асуухаас айхгүй, алдахаас эмээхгүй, өөрийгөө
                чөлөөтэй илэрхийлж сурах болно. Бидний тэргүүн зорилго өөр
                бусад зүйлсээс илүү хүүхэд бүрийн онцлогийг нээж, тэдэнд
                хэрэгцээтэй дэмжлэгийг үзүүлэх байж, энэ замд эцэг эх тантай
                нягт хамтран ажиллах болно. Хамтдаа бид таны хүүхдийг зөвхөн
                үсэг тоонд биш, харин сэтгэж, асууж, бүтээж сурахад нь хөтлөх
                юм.
              </div>
              <div>
                Томүжин Алтернатив сургуулиас өссөн хүүхэд ирээдүйд манлайлагч,
                шинийг санаачлагч, сэтгэгч, бүтээгчийн хувьд хүрээлэн буй
                орчин, хамт олондоо эерэг нөлөө үзүүлнэ гэдэгт бид итгэлтэй
                байна. Энэ урт аялалын эхлэлд гэр бүл танайхыг хүрээлэлдээ
                хүлээн авч байгаадаа туйлын баяртай байна.
              </div>
              <div>
                Томүжингийн нийт хамт олны нэрийн өмнөөс танд болон таны бяцхан
                суралцагчид дахин баяр хүргэе!
              </div>
              <br />
              <div>
                Хүндэтгэсэн, <br />
                Томүжин Алтернатив сургуулийн элсэлтийн баг
              </div>
            </div>
          </div>
        </div>

        {/* Санхүүгийн дэмжлэгийн форм — доош гүйлгэхэд */}
        <div className="w-full h-[60vh] bg-primary2 flex justify-center items-center">
          <div className="mx-auto max-w-[1280px] px-12 leading-[1.38] text-center">
            <div className="text-[20pt] md:text-[28pt] text-white mb-10">
              Санхүүгийн дэмжлэг хүсэх бол асран хамгаалагч дараах формыг
              зааврын дагуу бөглөж, илгээнэ үү.
            </div>
            <a
              href="https://form.jotform.com/260808191613456"
              target="_blank"
              rel="noreferrer"
            >
              <Button type="primary" size="large">
                Санхүүгийн дэмжлэгийн өргөдөл бөглөх →
              </Button>
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative">
      <Header />
      <div
        id="home-section"
        className="w-full flex justify-center items-center overflow-x-hidden relative"
        style={{
          background: `url(${width < height ? vertical : home})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          height: width < height ? "45vh" : "100vh",
        }}
      >
        {/* Dark overlay */}
        <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.10)" }} />

        <ReactConfetti gravity={0.2} style={{ width: "100%", height: "100vh" }} />

        <div className="max-w-[1280px] px-10 sm:px-24 xl:px-0 text-white sm:block relative z-10">
          <h1 className="text-[24pt] sm:text-[40pt] md:text-[60pt] xl:text-[80pt] font-extrabold leading-none">
            БАЯР ХҮРГЭЕ!
          </h1>
          <div className="mt-[34pt] text-[20pt] md:text-[35pt] xl:text-[50pt] leading-[1.38]">
            Та Томүжин Алтернатив сургуульд ТЭНЦЛЭЭ!
          </div>
        </div>
      </div>

      <div className="w-full min-h-screen flex justify-center items-center">
        <div className="max-w-[1280px]">
          <div className="w-2/3 flex flex-col gap-4 mx-auto py-20 md:py-0 font-sans">
            <div className="text-[20pt] md:text-[40pt] xl:text-[50pt] font-extrabold text-primary leading-[1.38]">
              Хүндэт {name},
            </div>
            <div className="mt-10 font-sans">
              Юуны түрүүнд энэ хүртэл өөрийгөө илэрхийлж, сорьж, өөртөө итгэх
              итгэл, хүсэл мөрөөдөл, үнэ цэнээ илэрхийлж, баталж харуулж
              чадсанд тань томоос том БАЯР ХҮРГЭЕ! Томүжин Алтернатив
              сургуулийн сурагч болсноор та Монгол улсын өнцөг булан бүрээс
              асар өндөр өрсөлдөөнтэй бүрэлдсэн хүрээллийн нэг хэсэг болж,
              олон зуун жил шинэчлэгдээгүй хэвшмэл боловсролыг халж
              #Алтернатив сургалтын арга технологийг эрэлхийлэх бидний энэхүү
              аялалд нэгдэж буй цөөхөн хэдэн сурагчдын нэг болж байгаа юм.
            </div>
            <div>
              Томүжин Алтернатив сургуульд та улам ихээр өөрийгөө сорьж,
              хүрээллийн гайхамшгийг мэдрэхийн сацуу олон төрлийн төсөл
              хэрэгжүүлснээр ахлах сургуулийнхаа дараах амьдралдаа бүрэн
              бэлтгэгдэнэ гэдэгт итгэлтэй байна. Бидний тэргүүн зорилго өөр
              бусад зүйлсээс илүү сурагч танд хэрэгцээтэй дэмжлэгийг үзүүлэх
              байж, таныг хүссэн үр дүнд чинь хүргэхийн төлөө бүхнээ зориулах
              болно. Томүжин Алтернатив сургуулийг төгсөөд та манлайлагч,
              шинийг санаачлагч, сэтгэгч, бүтээгчийн хувьд хүрээлэн буй орчин,
              хамт олондоо эерэг нөлөө үзүүлж, гэгээлэг ирээдүйн төлөө хамтдаа
              зүтгэнэ гэж бид найдаж байна.
            </div>
            <div>
              Томүжингийн нийт хамт олны нэрийн өмнөөс Томүжин Алтернатив
              сургуулийн хүрээллийн онцгой нэгэн бүрэлдэхүүн болсонд дахин
              баяр хүргэе!
            </div>
            <br />
            <div>
              Хүндэтгэсэн, <br />
              Томүжин Алтернатив сургуулийн элсэлтийн баг
            </div>
          </div>
        </div>
      </div>

      <div className="w-full h-[60vh] bg-primary2 flex justify-center items-center">
        <div className="mx-auto max-w-[1280px] px-12 leading-[1.38]">
          <div className="text-[25pt] md:text-[30pt] xl:text-[30pt] text-white mb-12">
            Элсэлтийн үе шатуудын явцын мэдээлэл рүүгээ буцаж орж дараагийн үе
            шатуудтайгаа танилцаарай.
          </div>
          <Button type="primary" size="large" onClick={() => navigate("/")}>
            Буцах
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Decision;